import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReleaseNotesService } from '../../services/master';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';

@Component({
  standalone: false,
  selector: 'app-whats-new-add',
  templateUrl: './whats-new-add.component.html',
  styleUrls: ['./whats-new-add.component.scss']
})
export class WhatsNewAddComponent implements OnInit {
  releaseNoteForm: FormGroup;
  today = new Date().toISOString().split('T')[0];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private releseNoteService: ReleaseNotesService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private permission: HasPermissionService,
  ) {}

  ngOnInit(): void {
    this.releaseNoteForm = this.fb.group({
      releaseNoteLabel: ['', Validators.required],
      initialDate: ['', Validators.required],
      endDate: ['', Validators.required],
      isActive: [true],
      releaseNotes: this.fb.array([this.fb.control('', Validators.required)])
    });
  }

  get releaseNotes(): FormArray {
    return this.releaseNoteForm.get('releaseNotes') as FormArray;
  }

  addNoteField(): void {
    this.releaseNotes.push(this.fb.control('', Validators.required));
  }

  removeNoteField(index: number): void {
    this.releaseNotes.removeAt(index);
  }

  back(): void {
    this.router.navigate(['/whats-new-list']);
  }

  save(): void {
    if (this.releaseNoteForm.invalid) return;

    const formValue = this.releaseNoteForm.value;

    const payload = {
      initialDate: formValue.initialDate,
      endDate: formValue.endDate,
      releaseNoteLabel: formValue.releaseNoteLabel,
      releaseNote: JSON.stringify({ ReleaseNotes: formValue.releaseNotes }),
      isActive: formValue.isActive
    };
   
    this.releseNoteService.apiReleaseNotesAddReleaseNotesPost(payload).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('Action.Success'));
        this.router.navigate(['/whats-new-list']);
      },
      error: () => {
        this.toastr.error(this.translate.instant('Action.Error'));
      }
    });
  }
}